import {useJobContext} from 'contexts';
import {
    transformDisplayName,
    transformDisplayNameEdge,
} from 'components/customer/Materials/helper';
import {useListBenchesQuery} from 'components/customer/BTM/store/btmApi';
import {Bench} from 'components/customer/BTM/entity/Bench';
import {mapDisplayName} from 'components/customer/BTM/helper/materialMappers';
import {mapMaterialEdge} from 'components/customer/Materials/helper/edgeHelper';
import {PartialJob} from 'shared/types/PartialJob';
import {mapMaterial} from 'components/customer/Materials/helper/materialHelper';
import {useCallback} from 'react';

type ExtMaterialType = {
    id: number;
};

export const useMapMaterialDisplayName = () => {
    const {job} = useJobContext() as PartialJob;
    const {data: {data: benches} = {data: [] as Bench[]}} = useListBenchesQuery(
        {
            jobId: job.id,
        },
        {
            skip: typeof job?.id === 'undefined',
        }
    );

    const mapEdgeDisplayName = useCallback(
        (edgeId: number) => {
            const roomEdge = job?.rooms
                ? job.rooms.flatMap((value) =>
                      value?.jobCabinets?.flatMap(
                          (cabinetValue) => cabinetValue?.extEdge
                      )
                  )
                : [];

            const edge = roomEdge?.find((m) => m?.id == edgeId);

            if (!edge) return null;
            return transformDisplayNameEdge(mapMaterialEdge(edge))?.displayName;
        },
        [job]
    );

    const mapMaterialDisplayName = useCallback(
        (materialId: number) => {
            const roomMaterials = job?.rooms
                ? job.rooms.flatMap((value) =>
                      value?.jobCabinets?.flatMap(
                          (cabinetValue) => cabinetValue?.extMaterial
                      )
                  )
                : [];

            const material = roomMaterials?.find(
                (m: ExtMaterialType) => m?.id == materialId
            );

            if (material)
                return transformDisplayName(mapMaterial(material)).displayName;

            const roomMaterialsCarc = job?.rooms
                ? job.rooms.flatMap((value) =>
                      value?.jobCabinets.flatMap(
                          (cabinetValue) => cabinetValue?.carcMaterial
                      )
                  )
                : [];

            const carcaseMaterial = roomMaterialsCarc?.find(
                (m: ExtMaterialType) => m?.id == materialId
            );

            if (carcaseMaterial)
                return transformDisplayName(mapMaterial(carcaseMaterial))
                    .displayName;

            if (benches) {
                const benchtopMaterial = benches?.find(
                    (m) => m?.material_id == materialId
                )?.material;

                if (benchtopMaterial) {
                    const benchTopMaterial = mapDisplayName(
                        {...benchtopMaterial},
                        false
                    );
                    return benchTopMaterial?.displayName;
                }
            }

            return mapEdgeDisplayName(materialId);
        },
        [mapEdgeDisplayName, job, benches]
    );

    return {
        mapMaterialDisplayName,
    };
};
